import { Link } from 'react-router-dom';
import { APPLICATIONS } from '@/lib/applications';
import { AppShowcaseCard } from '@/components/site/AppShowcaseCard';
import { useT } from '@/lib/i18n';
import { ArrowRight } from 'lucide-react';

export const ApplicationsTeaser = () => {
  const t = useT();
  const featured = APPLICATIONS.slice(0, 3);

  return (
    <section
      data-testid="section-applications-teaser"
      className="relative py-20 md:py-28"
    >
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-10">
        <div
          className="absolute left-[10%] top-[20%] h-[340px] w-[340px] rounded-full opacity-40 blur-3xl"
          style={{ background: 'radial-gradient(closest-side, rgba(16,185,129,0.20), transparent 70%)' }}
        />
      </div>

      <div className="om-container">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <span className="om-eyebrow">{t('home.applications_teaser.eyebrow')}</span>
            <h2
              data-testid="applications-teaser-title"
              className="om-h1 mt-5 text-[32px] sm:text-[40px] lg:text-[52px] text-[var(--om-ink)]"
            >
              {t('home.applications_teaser.title_l1')}<br />{t('home.applications_teaser.title_l2')}
            </h2>
          </div>
          <Link
            to="/applications"
            data-testid="applications-teaser-see-all"
            className="inline-flex items-center gap-2 rounded-full border border-[var(--om-border)] bg-white px-5 py-2.5 text-sm font-semibold text-[var(--om-ink)] transition-all duration-200 hover:-translate-y-[1px] hover:shadow-[0_10px_20px_-14px_rgba(10,14,26,0.25)]"
          >
            {t('home.applications_teaser.see_all')} <ArrowRight size={14} strokeWidth={2.4} />
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((app) => (
            <AppShowcaseCard key={app.id} app={app} />
          ))}
        </div>
      </div>
    </section>
  );
};
